import React from 'react';
import { targetAppStore } from '../store';
import { Percent, Info } from 'lucide-react';

interface DiscountEngineProps {
  appliedDiscounts: string[];
  isBug2Active: boolean;
  isPatched: boolean;
}

export const DiscountEngine: React.FC<DiscountEngineProps> = ({
  appliedDiscounts,
  isBug2Active,
  isPatched,
}) => {
  const RATES: Record<string, number> = {
    WELCOME20: 20,
    FLASH50: 50,
    VIP40: 40,
    SUMMER30: 30,
  };

  const rawSum = appliedDiscounts.reduce((sum, c) => sum + (RATES[c] || 20), 0);
  const effectiveRate = isPatched
    ? Math.min(70, rawSum)
    : isBug2Active
    ? rawSum
    : Math.min(70, rawSum);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: '10px 12px',
        background: 'var(--bg-input)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-sm)',
        fontSize: 11,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 600, color: 'var(--text-1)', display: 'flex', alignItems: 'center', gap: 4 }}>
          <Percent size={12} style={{ color: 'var(--purple)' }} /> Discount Engine Status
        </span>
        <span
          className={`badge ${effectiveRate > 100 ? 'badge-red' : effectiveRate > 50 ? 'badge-amber' : 'badge-green'}`}
          style={{ fontSize: 10 }}
        >
          {effectiveRate}% TOTAL DISCOUNT
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <span style={{ color: 'var(--text-3)' }}>Available Vouchers:</span>
        {Object.entries(RATES).map(([code, rate]) => {
          const isApplied = appliedDiscounts.includes(code);
          return (
            <button
              key={code}
              type="button"
              onClick={() => {
                if (isApplied) {
                  targetAppStore.removeDiscount(code);
                } else {
                  targetAppStore.applyDiscount(code);
                }
              }}
              style={{
                background: isApplied ? 'var(--purple-soft)' : 'var(--bg-card)',
                border: `1px solid ${isApplied ? 'var(--purple)' : 'var(--border)'}`,
                color: isApplied ? 'var(--purple)' : 'var(--text-2)',
                borderRadius: 4,
                padding: '2px 6px',
                fontSize: 10,
                cursor: 'pointer',
              }}
            >
              {code} (-{rate}%) {isApplied ? '✓' : '+'}
            </button>
          );
        })}
      </div>

      {effectiveRate > 100 && !isPatched && (
        <div style={{ color: 'var(--red)', display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
          <Info size={11} /> Exploit Condition: Discount rate exceeds 100%. Merchant owes customer money!
        </div>
      )}

      {isPatched && (
        <div style={{ color: 'var(--green)', display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
          <Info size={11} /> Autopatched: Cumulative discount ceiling enforced at 70% max.
        </div>
      )}
    </div>
  );
};
